import React from 'react';
import type { MotorAd } from '../../../types';
import type { AdImageProps } from '../../ad/AdImage';
import { AdImage } from '../../ad/AdImage';

type MotorImageProps = {
    ad: MotorAd;
    image?: (props: AdImageProps) => React.ReactElement | null;
    imageClass: string;
    sizes?: string;
};

export function MotorImage(props: MotorImageProps) {
    const { ad, image, imageClass, sizes } = props;

    const preserveAspect = Boolean(
        ad?.image?.aspect_ratio && ad.image.aspect_ratio >= 1,
    );
    const aspectClass = preserveAspect ? '' : 'aspect-3/2';

    const imageProps = {
        aspectClass,
        crop: true,
        imageClass,
        preserveAspect,
        sizes,
    };

    return image ? (
        image(imageProps)
    ) : (
        <AdImage {...imageProps} {...ad.image} />
    );
}
